import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, PRIMARY_OUTLET, Router } from '@angular/router';

import { OutletType } from './outlets.model';

@Injectable({ providedIn: 'root' })
export class ActivatedRouteService {
    private readonly router = inject(Router);

    getActivatedRoute(outlet: OutletType = PRIMARY_OUTLET): ActivatedRouteSnapshot {
        const rootRoute = this.router.routerState.snapshot.root;

        let route = rootRoute.children.find((c) => c.outlet === outlet) ?? rootRoute.firstChild;

        while (route?.firstChild) {
            route = route.firstChild;
        }

        return route ?? rootRoute;
    }
}
